import { Participant, ParticipantList, Room } from "@domain";
import { UniqueEntityId } from "@kernel/ddd";
import { SyncInteractor } from "@kernel/frontend-react-app";

export interface PinParticipantInteractorProps {
  room: Room;
  participantId: UniqueEntityId;
}

export class PinParticipantInteractor extends SyncInteractor<
  PinParticipantInteractorProps,
  Room
> {
  public execute({ room, participantId }: PinParticipantInteractorProps): Room {
    const participants = room.getThumbnailParticipants();
    const participant = participants.getById(participantId);
    this.unpinAllParticipants(participants);
    if (!participant) return room;
    participant.pin();
    return Room.createFromRoom(room);
  }

  private unpinAllParticipants(participants: ParticipantList<Participant>): void {
    for (const participant of participants.items) {
      participant.unpin();
    }
  }

  public static create(): PinParticipantInteractor {
    return new PinParticipantInteractor();
  }
}
